export var EventWS;
(function (EventWS) {
    EventWS["webSocketEventList"] = "websocket-event-list";
    EventWS["webSocketEventListReconnect"] = "websocket-event-list-reconnect";
    EventWS["webSocketChatReconnect"] = "websocket-chat-reconnect";
    EventWS["updateTeamDataBeforeStart"] = "update-team-data-before-start";
    EventWS["webSocketEventListNotMatch"] = "websocket-event-list-not-match";
})(EventWS || (EventWS = {}));
export var MiniGameEventType;
(function (MiniGameEventType) {
    MiniGameEventType["StreamingVideo"] = "streaming-video";
    MiniGameEventType["StopStreamingVideo"] = "stop-streaming-video";
    MiniGameEventType["ChangeBalance"] = "change-balance";
    MiniGameEventType["FetchBalance"] = "fetch-balance";
})(MiniGameEventType || (MiniGameEventType = {}));
export var WSDataFiled;
(function (WSDataFiled) {
    WSDataFiled["TYPE"] = "t";
    WSDataFiled["DATA"] = "d";
})(WSDataFiled || (WSDataFiled = {}));
export var WSDataTypeValue;
(function (WSDataTypeValue) {
    WSDataTypeValue["Today"] = "today";
    WSDataTypeValue["Live"] = "live";
    WSDataTypeValue["Current"] = "current";
})(WSDataTypeValue || (WSDataTypeValue = {}));
